module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23655",
      "conversations-internal-schema": "static-1.11562",
      "head-dlb": "static-1.4043",
      "hs-test-utils": "static-1.6924",
      "hubspot-url-utils": "static-1.3241",
      "HubStyleTokens": "static-2.10424",
      "I18n": "static-7.1395",
      "jasmine-runner": "static-1.5326",
      "quartz": "static-1.5667",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.464",
      "visitor-ui-component-library": "static-1.5105",
      "enviro": "static-4.306",
      "hs-promise-rejection-tracking": "static-1.4356",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4818",
      "raven-hubspot": "static-1.5125",
      "bend-plugin-trellis-migration": "static-1.2536",
      "moment": "static-3.26",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "quartz-core": "static-1.4886",
      "transmute": "static-2.29",
      "HeadJS": "static-2.581",
      "react-dom": "static-7.85",
      "foundations-components": "static-1-7234-button-link-children-spacing.31",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.2035",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.121",
      "foundations-theming": "static-1.3231",
      "i18n-data": "static-1.198",
      "metrics-js": "static-1.8682",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4412",
      "jasmine": "static-4.3258",
      "quartz-core-utils": "static-1.2534",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.39",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7371",
      "visitor-ui-component-library-icons": "static-1.4916",
      "bend-plugin-foundations-components": "static-1-7234-button-link-children-spacing.31",
      "floating-ui": "static-1.29",
      "foundations-assets": "static-1.3832",
      "foundations-theming-specialty": "static-1.948",
      "hs-story-utils": "static-1.8294",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.74",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "ui-images": "static-2.871",
      "copilot-toolkit": "static-1.6889",
      "dispatcher": "static-1.113",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.653",
      "hub-http-shared-msw-handlers": "static-1.7199",
      "hubspotter-http": "static-1.3667",
      "hubspotter-http-shared-msw-handlers": "static-1.7197",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.352",
      "platform-navigation-bootstrap": "static-1.11341",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15486",
      "react-router-dom": "static-5.26",
      "bend-plugin-foundations-theming": "static-1.1714",
      "foundations-theming-base": "static-1.2216",
      "classnames": "static-2.10",
      "cssUtils": "static-1.523",
      "HubStyle": "static-2.10732",
      "react-input-autosize": "static-2.17",
      "chatspot-client-types": "static-1.8798",
      "chatspot-core": "static-1.16186",
      "ts-schema": "static-1.3221",
      "sassPrefix": "static-1.132",
      "platform-infra-nav-components": "static-1.6784",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23655",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11562",
      "head-dlb": "/head-dlb/static-1.4043",
      "hs-test-utils": "/hs-test-utils/static-1.6924",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3241",
      "HubStyleTokens": "/HubStyleTokens/static-2.10424",
      "I18n": "/I18n/static-7.1395",
      "jasmine-runner": "/jasmine-runner/static-1.5326",
      "quartz": "/quartz/static-1.5667",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.464",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5105",
      "enviro": "/enviro/static-4.306",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4818",
      "raven-hubspot": "/raven-hubspot/static-1.5125",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2536",
      "moment": "/moment/static-3.26",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "quartz-core": "/quartz-core/static-1.4886",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.581",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1-7234-button-link-children-spacing.31",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2035",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.121",
      "foundations-theming": "/foundations-theming/static-1.3231",
      "i18n-data": "/i18n-data/static-1.198",
      "metrics-js": "/metrics-js/static-1.8682",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4412",
      "jasmine": "/jasmine/static-4.3258",
      "quartz-core-utils": "/quartz-core-utils/static-1.2534",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.39",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7371",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4916",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-7234-button-link-children-spacing.31",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-assets": "/foundations-assets/static-1.3832",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.948",
      "hs-story-utils": "/hs-story-utils/static-1.8294",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.74",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "ui-images": "/ui-images/static-2.871",
      "copilot-toolkit": "/copilot-toolkit/static-1.6889",
      "dispatcher": "/dispatcher/static-1.113",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.653",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7199",
      "hubspotter-http": "/hubspotter-http/static-1.3667",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7197",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.352",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11341",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15486",
      "react-router-dom": "/react-router-dom/static-5.26",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1714",
      "foundations-theming-base": "/foundations-theming-base/static-1.2216",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.523",
      "HubStyle": "/HubStyle/static-2.10732",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "chatspot-client-types": "/chatspot-client-types/static-1.8798",
      "chatspot-core": "/chatspot-core/static-1.16186",
      "ts-schema": "/ts-schema/static-1.3221",
      "sassPrefix": "/sassPrefix/static-1.132",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6784",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};